/***********************************************
* PhotoTool.js
* 
* Shows photos containing a point
***********************************************/
/* Layout files */
import '../assets/style/PhotoTool.css';

/* Global imports */
import React, { useState, useEffect, useCallback } from 'react';
import { withTranslation } from 'react-i18next';

/* Local imports */
import API from './API';
import { useAuthenticatedImage } from './useAuthenticatedImage';

const PhotoThumb = ({ projectId, imgId, selected, onSelect }) => {
    const src = '/media/thumb?project_id=' + projectId + '&image_id=' + imgId;
    const { url, loading, error } = useAuthenticatedImage(src);

    if (loading) return <div className="spinner">...</div>;
    if (error) return <div className="error-icon"><span role="img">⚠️</span></div>;
  
    return <img src={url} className={"photoImg " + (selected ? "selected" : "")} onClick={() => onSelect(imgId)} alt=""/>;  
};

const PhotoImage = ({ projectId, imgId, name, t }) => {
    const src = '/media/image?project_id=' + projectId + '&image_id=' + imgId;
    const { url, loading, error } = useAuthenticatedImage(src);
  
    if (loading) return <div><div className="spinner"></div></div>;
    if (error) return <div className="error-icon"><span role="img">⚠️</span></div>;
  
    return (
        <>
            <a className='button hugeButton smallerText' href={url} download={name + "_" + imgId + ".jpg"} target="_blank" rel="noopener noreferrer">{t("download")}</a>
            <img src={url} className="photoPreview" alt=""/>
        </>
    );
};

function PhotoTool(props) {
    const [photoList, setPhotoList] = useState([]);
    const [selectedPhoto, setSelectedPhoto] = useState(0);
    const [selectedRange, setSelectedRange] = useState(0);
    const [isDownloadingZip, setIsDownloadingZip] = useState(false);

    const handleSelect = useCallback((photoId) => {
        setSelectedPhoto(photoId);
    }, []);

    useEffect(() => {
        setSelectedPhoto(0);
    }, [props.id]);

    useEffect(() => {
        setSelectedPhoto(0);
        API.GetPhotoList(props.id, props.pickedPoint, (reply) => {
            var data = reply["visible"];
            data.sort((a, b) => a.dist - b.dist);
            setPhotoList(data); 
            setSelectedRange(data.length);
        });
    }, [props.pickedPoint]);

    return (
        <div className='photoTool'>
            <div className='selection'>
                <span><b>Distance</b></span>
                <br/>
                <span>Min</span>
                <input 
                    type="range" 
                    min="0" 
                    max={photoList.length} 
                    onChange={(e) => setSelectedRange(e.target.value)} 
                    value={selectedRange} 
                />
                <span>Max</span>
            </div>
            <div className='downloadAll'>
                {(isDownloadingZip) ? 
                    <button disabled>Downloading</button> :
                    <button onClick={() => { setIsDownloadingZip(true); API.DownloadZip(props.id, photoList.slice(0, selectedRange, () => setIsDownloadingZip(false))); }}>Download All</button>
                }
            </div>
            <div className='photoList'>
                {
                    photoList.slice(0, selectedRange).map((photo) => {
                        return <PhotoThumb key={photo.id} projectId={props.id} imgId={photo.id} selected={selectedPhoto === photo.id} onSelect={handleSelect}/>
                    })
                }
            </div>
            <div className='photoView'>
                {(selectedPhoto === 0) ? 
                    <div className="photoPreview">Select a photo</div> : 
                    <PhotoImage key="image" projectId={props.id} imgId={selectedPhoto} name={props.name} t={props.t}/> 
                }
            </div>
        </div>
    );
}

export default withTranslation("Projects")(PhotoTool);